import type { AvatarData } from '@/api/gen/_model/avatarData';
import { TextAvatar } from '@/shared/components';
import { UserAvatar } from '@/shared/features/user-avatar';
export function ClassroomAvatarPair({
  classroomId,
  classroomName,
  ownerAvatarData
}: {
  classroomId?: string;
  classroomName: string;
  ownerAvatarData?: AvatarData;
}) {
  return <div className="flex items-center" data-sentry-component="ClassroomAvatarPair" data-sentry-source-file="ClassroomAvatarPair.tsx">
      <TextAvatar text={classroomName} colorSeed={classroomId ?? classroomName} className="z-[1] border border-[rgba(28,27,31,0.04)] ring-4 ring-white" data-sentry-element="TextAvatar" data-sentry-source-file="ClassroomAvatarPair.tsx" />
      <UserAvatar avatarData={ownerAvatarData} useSprite spritePixelSize={40} className="-ml-2 bg-violet-50" data-sentry-element="UserAvatar" data-sentry-source-file="ClassroomAvatarPair.tsx" />
    </div>;
}